import { useState, useEffect } from "react";
import { Switch, Route, useLocation, Redirect } from "react-router-dom";
import NavBar from "../components/NavBar";
import Home from "../pages/Home";
import HomeV2 from "../pages/HomeV2";
import HomeInflu from "../pages/HomeInflu";
import PersonalData from "../pages/PersonalData";
import Experience from "../pages/Experience";
import DescriptiveQuestions from "../pages/DescriptiveQuestions";
import SubmitForm from "../pages/SubmitForm";
import CompletedSubscription from "../pages/CompletedSubscription";
import TermosCondicoes from "../pages/TermosCondicoes";
import NotMeetRequirements from "../pages/NotMeetRequirements";
import RedirectPage from "../pages/RedirectPage";
import RedirectPageV2 from "../pages/RedirectPageV2";
import RedirectPageInflu from "../pages/RedirectPageInflu";

const Routes = () => {
  const { pathname } = useLocation();
  const [email, setEmail] = useState("");

  useEffect(() => {
    setEmail(localStorage.getItem("email") || "");
  }, []);

  const onChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <>
      {pathname !== "/completed_subscription" &&
        pathname !== "/not_meet_requirements" &&
        pathname !== "/termos-condicoes" && <NavBar />}

      <Switch>
        <Route exact path="/">
          <Home email={email} setEmail={onChange} />
        </Route>

        <Route exact path="/v2">
          <HomeV2 email={email} setEmail={onChange} />
        </Route>

        <Route exact path="/influ">
          <HomeInflu email={email} setEmail={onChange} />
        </Route>

        <Route exact path="/personal_data">
          <PersonalData email={email} setEmail={onChange} formId={157} />
        </Route>

        <Route exact path="/personal_data-influ">
          <PersonalData email={email} setEmail={onChange} formId={162} />
        </Route>

        <Route exact path="/experience">
          <Experience email={email} setEmail={onChange} />
        </Route>

        <Route exact path="/descriptive_questions">
          <DescriptiveQuestions email={email} setEmail={onChange} />
        </Route>

        <Route exact path="/submit_form">
          <SubmitForm email={email} setEmail={onChange} formId={17} />
        </Route>

        <Route exact path="/submit_form-influ">
          <SubmitForm email={email} setEmail={onChange} formId={163} />
        </Route>

        <Route
          exact
          path="/completed_subscription"
          component={CompletedSubscription}
        />
        <Route exact path="/termos-condicoes" component={TermosCondicoes} />
        <Route
          exact
          path="/not_meet_requirements"
          component={NotMeetRequirements}
        />
        <Route exact path="/redirect" component={RedirectPage} />
        <Route exact path="/redirect-v2" component={RedirectPageV2} />
        <Route exact path="/redirect-influ" component={RedirectPageInflu} />

        <Redirect push to="/" />
      </Switch>
    </>
  );
};

export default Routes;
